/*
 * The main entry file for public JS and CSS
 */

// import some helpers from jQuery UI
require("jquery-ui/ui/unique-id.js");
require("jquery-ui/ui/focusable.js");
require("jquery-ui/ui/tabbable");
require("jquery-ui/ui/scroll-parent.js");
var popup = require("jquery-popup-overlay");

/* Global JS */
require("./scripts/global.js");

// Mobile Menu logic
require("./scripts/mobile-menu.js");

// Fake scroll
window.expertiseScroller = document.querySelector(".expertise-scroller");
if (window.expertiseScroller) {
  require("./scripts/fake-scroll.js");
}

/* Main Styles */
require('./styles/style.scss');

// TEST ES module loading
require("./scripts/es-module.mjs");

// Jump Links
window.$jumpTitles = $(".jumpTitle");
window.$jumpLinks = $(".jumpLinks");
if (window.$jumpTitles.length && window.$jumpLinks.length) {
  import(/* webpackChunkName: "jump-links" */"./scripts/jump-links.cjs");
}

// Sliders
var $sliders = $(".splide");
if ($sliders.length) {
  import(/* webpackChunkName: "sliders" */"./scripts/sliders.cjs");
}

// Dynamic widget scripts (helps ensure proper loading order, and possibly help improve some scores)
// ToDo: flesh this out further and add support for priortity and/or dependency references
function loadDynamicWidgetScripts() {
  $("script[data-src]").each(function () {
    var url = $(this).data("src");
    $(this).attr("data-src", "").attr("src", url);
  });
}
loadDynamicWidgetScripts();